import React, { useReducer, createContext } from "react";

const initialState = {
  ApiKey: "",
};

const ApiContext = createContext({
  ApiKey: "",
  SetApikey: (data) => {},
});

function apiReducer(state, action) {
  switch (action.type) {
    case "SET_KEY": {
      return {
        ...state,
        ApiKey: action.payload,
      };
    }
    default:
      return state;
  }
}

function ApiProvider(props) {
  const [state, dispatch] = useReducer(apiReducer, initialState);

  const SetApikey = (data) => {
    dispatch({
      type: "SET_KEY",
      payload: data,
    });
  };

  return (
    <ApiContext.Provider
      value={{ ApiKey: state.ApiKey, SetApikey }}
      {...props}
    />
  );
}

export { ApiContext, ApiProvider };
